import {BuyerInfoFragment} from '../../../gql/graphql';
import {mapNullToUndefined} from '../../utils/mapperHelper.utils';

export class CustomerInfoModel {
  public languageCode: string;
  public email?: string;
  public contactId?: string;

  constructor(params: CustomerInfoModel) {
    this.languageCode = params.languageCode;
    this.email = params.email;
    this.contactId = params.contactId;
  }

  public static fromCheckoutV1(languageCode: string, buyerInfo?: BuyerInfoFragment | null) {
    return new CustomerInfoModel({
      languageCode,
      email: mapNullToUndefined(buyerInfo?.email),
      contactId: mapNullToUndefined(buyerInfo?.contactId),
    });
  }
}
